import { Button, Dialog, DialogBody, DialogFooter, Intent } from '@blueprintjs/core'
import * as React from 'react'
import Client from '../../../../client'
import Errors from '../../../../components/Errors'
import { DialogProps, DialogState } from './Types'
import { showSuccess } from '../../../../Toast'

class RestoreDialog extends React.Component<DialogProps, DialogState> {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      loading: false
    }
  }

  onRestore = async () => {
    this.setState({ loading: true })
    try {
      await Client.recycleProduct(this.props.productId, false)
      this.setState({ loading: false })
      this.props.onComplete()
      showSuccess('Product Restored!')
    } catch (error) {
      this.setState({ loading: false, error: error.response.data })
    }
  }

  onClose = () => {
    this.setState({ error: null }, () => {
      this.props.onClose(null)
    })
  }

  render() {
    const { error, loading } = this.state

    return (
      <Dialog title="Restore Product" isOpen={!!this.props.productId} onClose={() => this.onClose()}>
        <DialogBody>
          <Errors error={error} />
          <div>
            <ul>
              <li>This will restore your product</li>
              <li>This product will be moved from the Recycled tab to the Products tab</li>
              <li>This product&apos;s listings will be visible in the Listing Manager</li>
              <li>This will NOT relist the product&apos;s listings</li>
            </ul>
          </div>
        </DialogBody>
        <DialogFooter
          actions={
            <>
              <Button intent={Intent.NONE} onClick={() => this.onClose()}>
                Cancel
              </Button>
              <Button loading={loading} intent={Intent.PRIMARY} onClick={this.onRestore}>
                Restore
              </Button>
            </>
          }
        />
      </Dialog>
    )
  }
}

export default RestoreDialog
